import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballCompetitionService } from "../../../../../commons";
import { EnsueCollection } from "../../../../../ensue-react-system/utilities/ensue-collection";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";

export interface IManageCompetitionSeasonAvailableInviteTeamsState {
  competitionSeasonAvailableInviteTeams: EnsueCollection<ManageFootballTeam>;
  competitionSeasonAvailableInviteTeamsStatus: StatusEnum;
}

export interface IManageCompetitionAvailableInviteTeamsOption {
  competitionId: number;
  seasonId: number;
  urlParams?: {
    hostTeamId?: number;
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: string;
    status?: string;
    name?: string;
  };
}

const initialState: IManageCompetitionSeasonAvailableInviteTeamsState = {
  competitionSeasonAvailableInviteTeams: new EnsueCollection<ManageFootballTeam>(),
  competitionSeasonAvailableInviteTeamsStatus: StatusEnum.Idle,
};

export const fetchCompetitionSeasonAvailableInviteTeams = createAsyncThunk(
  "manage/competitionSeasonAvailableInviteTeams",
  async (options: IManageCompetitionAvailableInviteTeamsOption, thunkAPI) => {
    try {
      const competitionAvailableInviteTeams = await manageFootballCompetitionService.getAvailableInviteTeamList(
        options.competitionId,
        options.seasonId,
        options.urlParams
      );
      return competitionAvailableInviteTeams;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageCompetitionSeasonAvailableInviteTeamsSlice = createSlice({
  name: "competitionSeasonAvailableInviteTeams",
  initialState: initialState,
  reducers: {
    cleanUpCompetitionSeasonAvailableInviteTeams(state) {
      state.competitionSeasonAvailableInviteTeams = new EnsueCollection<ManageFootballTeam>();
      state.competitionSeasonAvailableInviteTeamsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCompetitionSeasonAvailableInviteTeams.pending, (state) => {
        state.competitionSeasonAvailableInviteTeamsStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchCompetitionSeasonAvailableInviteTeams.fulfilled,
        (state, action: PayloadAction<EnsueCollection<ManageFootballTeam>>) => {
          state.competitionSeasonAvailableInviteTeamsStatus = StatusEnum.Succeeded;
          state.competitionSeasonAvailableInviteTeams = action.payload;
        }
      )
      .addCase(fetchCompetitionSeasonAvailableInviteTeams.rejected, (state) => {
        state.competitionSeasonAvailableInviteTeamsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpCompetitionSeasonAvailableInviteTeams } = manageCompetitionSeasonAvailableInviteTeamsSlice.actions;
export default manageCompetitionSeasonAvailableInviteTeamsSlice.reducer;
